var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"1000"},model:{value:(_vm.showMoal),callback:function ($$v) {_vm.showMoal=$$v},expression:"showMoal"}},[_c('p',{staticClass:"text-center",attrs:{"slot":"header"},slot:"header"},[_vm._v("租赁记录")]),_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.tableLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }